import { render } from "./Reversal.vue?vue&type=template&id=b4f71736"
import script from "./Reversal.vue?vue&type=script&lang=js"
export * from "./Reversal.vue?vue&type=script&lang=js"

import "./Reversal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__